import configuration from "../configuration/keys";
import { FOOTER_FONT_SIZE, FOOTER_HEIGHT } from "../constants/core-constants";
import i18n from "../constants/i18n";
import ET3Div from "../core/et3-div";
import { withLiteObserverAndTheme } from "../core/et3-enhanced-render";
import Et3Text from "../core/et3-text";

const Footer = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  return (
    <footer
      style={{
        backgroundColor: colors.all.transparent
      }}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="center"
        withShadow={false}
        width={0}
        height={FOOTER_HEIGHT}
        color={colors.all.transparent}
        style={{ width: "100%", minWidth: 0 }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={FOOTER_FONT_SIZE}
          text={`${i18n.get("COPYRIGHT")} ${i18n.get(
            "ET3ARRAF_SAL"
          )}  ${i18n.get("ALL_RIGHTS_RESERVED")} ${i18n.get(
            "VERSION"
          )} ${configuration.version}`}
          isSpan={false}
          color={colors.all.davysGrey}
          style={{ margin: 0 }}
        />
      </ET3Div>
    </footer>
  );
});
export default Footer;
